<template>
  <el-dialog
    :title="globalMode ? '系统预设属性设置' : '类目属性设置'"
    :visible="visible"
    width="92%"
    top="4vh"
    class="custom-el-wrapper"
    custom-class="doudian-category-attribute-dialog"
    :close-on-click-modal="false"
    :before-close="handleBeforeClose"
    @open="handleOpen"
  >
    <div class="dialog-tip">{{ globalMode
      ? '配置保存为系统预设属性；普通店铺需二次确认后同步到自己的模板。'
      : '配置类目属性后，当前搬家模板下的商品默认使用这些属性值。' }}</div>
    <div class="attribute-layout">
      <aside class="category-panel" :class="{ 'global-mode': globalMode }">
        <el-input
          v-model="filters.keyword"
          placeholder="搜索类目名称/抖店分类ID"
          clearable
          prefix-icon="el-icon-search"
          @input="queueLoadCategories"
        />
        <div class="filter-tabs">
          <button
            v-for="tab in categoryTabs"
            :key="tab.value"
            type="button"
            :class="{ active: filters.configured === tab.value }"
            @click="changeConfiguredFilter(tab.value)"
          >{{ tab.label }}</button>
        </div>
        <div class="category-list" v-loading="categoryLoading">
          <button
            v-for="item in categories"
            :key="item.category_id"
            type="button"
            class="category-item"
            :class="{ active: Number(activeCategory.category_id) === Number(item.category_id) }"
            @click="selectCategory(item)"
          >
            <span class="category-path">{{ categoryPath(item) }}</span>
            <i v-if="item.is_configured" class="el-icon-success configured-icon" />
          </button>
          <el-empty v-if="!categoryLoading && categories.length === 0" description="暂无符合条件的类目" :image-size="70" />
        </div>
        <el-pagination
          v-if="globalMode && total > pageSize"
          class="category-pagination"
          small
          layout="prev, pager, next"
          :current-page="page"
          :page-size="pageSize"
          :total="total"
          @current-change="changePage"
        />
      </aside>

      <section class="property-panel">
        <div class="property-header">
          <div>
            <strong>当前类目：</strong>{{ activeCategory.path_names || '请选择左侧类目' }}
            <span v-if="activeCategory.category_id" class="category-id">ID：{{ activeCategory.category_id }}</span>
          </div>
          <span>{{ globalMode ? '系统预设已配置' : '当前模板已配置' }} {{ configuredCount }} 个类目</span>
        </div>
        <div class="property-list" v-loading="propertyLoading">
          <el-empty v-if="!activeCategory.category_id" description="请先选择需要配置的叶子类目" />
          <el-empty
            v-else-if="!propertyLoading && properties.length === 0"
            description="该类目暂无可配置属性"
          />
          <div v-if="activeCategory.category_id && properties.length" class="property-section-title">类目属性：</div>
          <template v-for="property in properties">
            <div :key="`property_${property.property_id}`" class="property-row">
              <div class="property-enable">
                <el-checkbox v-model="property.config.enabled" @change="markDirty" />
              </div>
              <div class="property-name">
                <span v-if="property.required" class="required">*</span>{{ property.property_name }}：
              </div>
              <div class="property-control">
                <template v-if="property.type === 'select'">
                  <el-select
                    v-model="property.config.value_id"
                    filterable
                    clearable
                    placeholder="请选择"
                    class="control-full"
                    @change="enableProperty(property)"
                  >
                    <el-option
                      v-for="option in property.options"
                      :key="String(option.value)"
                      :label="option.name"
                      :value="String(option.value)"
                    />
                  </el-select>
                  <el-button
                    v-if="Number(property.diy_type) === 1"
                    type="text"
                    @click="addCustomOption(property)"
                  >+ 创建属性值</el-button>
                </template>
                <template v-else-if="['multi_select', 'cascader_multi_select'].includes(property.type)">
                  <el-select
                    v-if="Number(property.diy_type) === 1"
                    v-model="property.config.value_ids"
                    multiple
                    filterable
                    clearable
                    :multiple-limit="property.multi_select_max"
                    placeholder="请选择"
                    class="control-full"
                    @change="enableProperty(property)"
                  >
                    <el-option
                      v-for="option in property.options"
                      :key="String(option.value)"
                      :label="option.name"
                      :value="String(option.value)"
                    />
                  </el-select>
                  <el-checkbox-group
                    v-else
                    v-model="property.config.value_ids"
                    :max="property.multi_select_max || undefined"
                    @change="enableProperty(property)"
                  >
                    <el-checkbox
                      v-for="option in property.options"
                      :key="String(option.value)"
                      :label="String(option.value)"
                    >{{ option.name }}</el-checkbox>
                  </el-checkbox-group>
                  <el-button
                    v-if="Number(property.diy_type) === 1"
                    type="text"
                    @click="addCustomOption(property)"
                  >+ 创建属性值</el-button>
                </template>
                <el-input
                  v-else-if="property.type === 'text'"
                  v-model="property.config.text_value"
                  placeholder="请输入属性值"
                  @input="enableProperty(property)"
                />
                <template v-else-if="isStructuredProperty(property)">
                  <div
                    v-for="(measure, measureIndex) in property.config.measure_infos"
                    :key="`${property.property_id}_${measureIndex}`"
                    class="measure-row"
                    :class="{ 'has-prefix': measureHasPrefix(measure) }"
                  >
                    <div class="measure-fields">
                      <div v-for="value in measure.values" :key="value.module_id" class="measure-value">
                        <div
                          v-if="measureHasPrefix(measure)"
                          class="measure-value-prefix"
                          :class="{ empty: !measurePrefix(value) }"
                        >{{ measurePrefix(value) || '占位' }}</div>
                        <el-date-picker
                          v-if="isDateModule(value)"
                          v-model="value.value"
                          :type="datePickerType(value)"
                          :value-format="dateValueFormat(value)"
                          :placeholder="value.display_name || '请选择日期'"
                          class="control-full"
                          @change="enableProperty(property)"
                        />
                        <el-select
                          v-else-if="value.input_type === 'enum_diy'"
                          v-model="value.value"
                          filterable
                          allow-create
                          default-first-option
                          placeholder="请选择"
                          class="control-full"
                          @change="enableProperty(property)"
                        >
                          <el-option
                            v-for="option in measureOptions(value)"
                            :key="option.value_name"
                            :label="option.value_name"
                            :value="option.value_name"
                          />
                        </el-select>
                        <el-input
                          v-else
                          v-model="value.value"
                          :type="isNumericModule(value) ? 'number' : 'text'"
                          :min="measureMin(value)"
                          :max="measureMax(value)"
                          :step="measureStep(value)"
                          placeholder="请输入"
                          @input="enableProperty(property)"
                        >
                          <el-select
                            v-if="measureUnits(value).length > 1"
                            slot="append"
                            v-model="value.unit_id"
                            class="measure-unit-select"
                            @change="changeMeasureUnit(value, property)"
                          >
                            <el-option
                              v-for="unit in measureUnits(value)"
                              :key="String(unit.unit_id)"
                              :label="unit.unit_name"
                              :value="unit.unit_id"
                            />
                          </el-select>
                          <template v-else-if="value.unit_name" slot="append">{{ value.unit_name }}</template>
                        </el-input>
                      </div>
                    </div>
                    <el-button
                      v-if="property.type === 'multi_value_measure' && isFirstMeasureForTemplate(property, measureIndex) && canAddMeasure(property)"
                      type="text"
                      icon="el-icon-plus"
                      @click="addMeasure(property, measure.template_id)"
                    />
                    <el-button
                      v-if="property.type === 'multi_value_measure' && !isFirstMeasureForTemplate(property, measureIndex)"
                      type="text"
                      icon="el-icon-minus"
                      @click="removeMeasure(property, measureIndex)"
                    />
                  </div>
                </template>
                <el-input
                  v-else
                  v-model="property.config.text_value"
                  placeholder="请输入属性值"
                  @input="enableProperty(property)"
                />
              </div>
              <div class="apply-mode">
                <el-radio-group v-model="property.config.apply_mode" @change="markDirty">
                  <el-radio label="force">强制使用</el-radio>
                  <el-radio label="unmatched_only">应用至未自动匹配</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div
              v-if="showPropertyImages(property)"
              :key="`property_image_${property.property_id}`"
              class="property-row property-image-row"
            >
              <div class="property-enable image-help">
                <el-tooltip
                  placement="top-start"
                  effect="dark"
                  popper-class="doudian-property-image-tooltip"
                >
                  <div slot="content">
                    <div class="image-tooltip-title">水洗标/吊牌图规则</div>
                    <div>1、水洗标：缝在领口、衣角内侧的小布标，通常包含面料材质等信息</div>
                    <div>2、上传水洗标或吊牌图任一类型即可，图片需包含完整的材质、成分占比等文字信息，尺寸至少400px以上，大小5M内，图片格式支持：jpg/jpeg/png</div>
                  </div>
                  <button type="button" class="image-help-button" aria-label="查看水洗标/吊牌图规则">
                    <i class="el-icon-question" />
                  </button>
                </el-tooltip>
              </div>
              <div class="property-name">
                <span v-if="propertyImageRequired(property)" class="required">*</span>水洗标/吊牌图：
              </div>
              <div class="property-images">
                <div
                  v-for="(url, imageIndex) in property.config.image_urls"
                  :key="`${property.property_id}_image_${imageIndex}`"
                  class="property-image-item"
                >
                  <el-image
                    :src="url"
                    :preview-src-list="property.config.image_urls"
                    fit="cover"
                    class="property-image"
                  >
                    <div slot="error" class="property-image-error"><i class="el-icon-picture-outline" /></div>
                  </el-image>
                  <i class="el-icon-close property-image-remove" @click="removePropertyImage(property, imageIndex)" />
                </div>
                <el-upload
                  v-if="property.config.image_urls.length < propertyImageLimit(property)"
                  action="#"
                  accept="image/jpeg,image/png,image/webp"
                  :show-file-list="false"
                  :disabled="isUploadingImage(property)"
                  :before-upload="file => beforePropertyImageUpload(file, property)"
                  :http-request="customUpload"
                  :on-success="(res, file) => handlePropertyImageSuccess(res, file, property)"
                  :on-error="(err, file) => handlePropertyImageError(err, file, property)"
                >
                  <div class="property-image-add" :class="{ 'is-uploading': isUploadingImage(property) }">
                    <i v-if="!isUploadingImage(property)" class="el-icon-plus" />
                    <i v-else class="el-icon-loading" />
                  </div>
                </el-upload>
                <div class="property-image-note">
                  {{ propertyImageRequired(property) ? '该图片为必传项' : `最多上传 ${propertyImageLimit(property)} 张` }}
                </div>
              </div>
              <div class="apply-mode">
                <el-radio-group v-model="property.config.apply_mode" @change="markDirty">
                  <el-radio label="force">强制使用</el-radio>
                  <el-radio label="unmatched_only">应用至未自动匹配</el-radio>
                </el-radio-group>
              </div>
            </div>
          </template>
        </div>
      </section>
    </div>
    <span slot="footer">
      <el-button @click="requestClose">关闭</el-button>
      <el-button type="primary" :loading="saving" :disabled="!activeCategory.category_id" @click="saveConfig">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import config from '@/assets/js/conf/config'
import { uploadDirectOss } from '@/assets/js/utils/ossDirectUpload'

export default {
  name: 'CategoryAttributeDialog',
  props: {
    visible: { type: Boolean, default: false },
    shopId: { type: Number, required: true },
    templateId: { type: [Number, String], required: true },
    globalMode: { type: Boolean, default: false }
  },
  data() {
    return {
      filters: { keyword: '', configured: 'all' },
      categoryTabs: [
        { label: '全部分类', value: 'all' },
        { label: '已配置', value: 'yes' },
        { label: '未配置', value: 'no' }
      ],
      categories: [],
      configuredCount: 0,
      page: 1,
      pageSize: 100,
      total: 0,
      activeCategory: {},
      properties: [],
      categoryLoading: false,
      propertyLoading: false,
      saving: false,
      dirty: false,
      searchTimer: null,
      uploadingImageIds: [],
    }
  },
  computed: {
    uploadHeaders() {
      return {
        Authorization: `Bearer ${localStorage.getItem(config.tokenKey) || ''}`
      }
    }
  },
  watch: {
    templateId() {
      if (this.visible) {
        this.activeCategory = {}
        this.properties = []
        this.loadCategories()
      }
    }
  },
  beforeDestroy() {
    if (this.searchTimer) clearTimeout(this.searchTimer)
  },
  methods: {
    ...mapActions({
      getCategories: 'ucenter/getDoudianMoveCategories',
      getProperties: 'ucenter/getDoudianMoveCategoryProperties',
      saveCategory: 'ucenter/saveDoudianMoveCategoryConfig',
      getGlobalProperties: 'ucenter/getDoudianMoveGlobalCategoryProperties',
      saveGlobalCategory: 'ucenter/saveDoudianMoveGlobalCategoryConfig'
    }),
    handleOpen() {
      this.filters = { keyword: '', configured: 'all' }
      this.page = 1
      this.activeCategory = {}
      this.properties = []
      this.dirty = false
      this.loadCategories()
    },
    queueLoadCategories() {
      if (this.searchTimer) clearTimeout(this.searchTimer)
      this.page = 1
      this.searchTimer = setTimeout(this.loadCategories, 300)
    },
    changeConfiguredFilter(value) {
      if (this.filters.configured === value) return
      this.filters.configured = value
      this.page = 1
      this.loadCategories()
    },
    changePage(page) {
      this.page = page
      this.loadCategories()
    },
    loadCategories(keepCategory = false) {
      if (!this.globalMode && !this.templateId) return
      this.categoryLoading = true
      const activeId = keepCategory ? Number(this.activeCategory.category_id || 0) : 0
      this.getCategories({
        shopId: this.shopId,
        data: {
          template_id: this.templateId,
          keyword: this.filters.keyword,
          configured: this.filters.configured,
          page: this.page,
          page_size: this.pageSize
        },
        success: res => {
          this.categoryLoading = false
          if (res.code !== 200) {
            this.$message.error(res.msg || '获取类目失败')
            return
          }
          const data = res.data || {}
          this.categories = data.categories || []
          this.configuredCount = Number(data.configured_count || 0)
          this.total = Number(data.total || this.categories.length)
          if (activeId) {
            const active = this.categories.find(item => Number(item.category_id) === activeId)
            if (active) this.activeCategory = active
          }
        }
      })
    },
    categoryPath(item) {
      const path = item && item.path_names
      if (Array.isArray(path)) return path.filter(Boolean).join('>')
      const text = String(path || item.name || '').trim()
      if (text.charAt(0) === '[') {
        try {
          const values = JSON.parse(text)
          if (Array.isArray(values)) return values.filter(Boolean).join('>')
        } catch (error) {}
      }
      return text.replace(/\s*>\s*/g, '>')
    },
    selectCategory(item) {
      const load = () => {
        this.activeCategory = item
        this.loadProperties()
      }
      if (!this.dirty) return load()
      this.$confirm('当前类目有未保存的修改，切换后将丢失，是否继续？', '提示', { type: 'warning' })
        .then(load)
        .catch(() => {})
    },
    loadProperties() {
      this.propertyLoading = true
      this.dirty = false
      const action = this.globalMode ? this.getGlobalProperties : this.getProperties
      action({
        shopId: this.shopId,
        templateId: this.templateId,
        categoryId: this.activeCategory.category_id,
        success: res => {
          this.propertyLoading = false
          if (res.code !== 200) {
            this.$message.error(res.msg || '获取类目属性失败')
            return
          }
          const data = res.data || {}
          const saved = data.config || {}
          this.properties = (data.properties || [])
            .map(item => this.normalizeProperty(item, saved[String(item.property_id)] || {}))
            .filter(item => item.status === undefined || Number(item.status) === 0)
            .filter(item => {
              return !['select', 'multi_select', 'cascader_multi_select'].includes(item.type)
                || item.options.length > 0
                || Number(item.diy_type) === 1
            })
        }
      })
    },
    normalizeProperty(item, saved) {
      const property = Object.assign({}, item)
      const optionSource = (property.options || []).length ? property.options : (property.property_values || [])
      property.options = optionSource.map(option => {
        const value = option.value !== undefined && option.value !== null && option.value !== ''
          ? option.value
          : (option.value_id !== undefined ? option.value_id : option.name)
        return Object.assign({}, option, {
          name: option.name || option.value_name || String(value || ''),
          value: String(value)
        })
      })
      const type = property.type || 'text'
      property.property_name = property.property_name || property.name || ''
      property.required = Number(property.required || property.is_required || 0)
      property.diy_type = Number(property.diy_type || property.support_diy_type || 0)
      property.multi_select_max = Math.max(0, Number(property.multi_select_max || 0))
      property.measure_templates = Array.isArray(property.measure_templates) ? property.measure_templates : []
      property.property_pic_rule = property.property_pic_rule && typeof property.property_pic_rule === 'object'
        ? property.property_pic_rule
        : {}
      property.config = {
        enabled: Boolean(saved.enabled),
        value_type: type,
        value_id: saved.value_id !== undefined ? String(saved.value_id) : '',
        value_ids: Array.isArray(saved.value_ids) ? saved.value_ids.map(String) : [],
        text_value: saved.text_value || '',
        measure_infos: this.normalizeMeasureInfos(property, saved.measure_infos),
        image_urls: Array.isArray(saved.image_urls) ? saved.image_urls.filter(Boolean) : [],
        apply_mode: saved.apply_mode === 'unmatched_only' ? 'unmatched_only' : 'force'
      }
      return property
    },
    normalizeMeasureInfos(property, savedInfos) {
      const templates = property.measure_templates || []
      if (!this.isStructuredProperty(property)) return []
      const parsed = (Array.isArray(savedInfos) ? savedInfos : []).map(info => {
        if (typeof info !== 'string') return info
        try {
          return JSON.parse(info)
        } catch (error) {
          return null
        }
      }).filter(info => info && typeof info === 'object')
      const result = []
      templates.forEach(template => {
        const rows = parsed.filter(info => String(info.template_id) === String(template.template_id))
        if (!rows.length) {
          result.push(this.makeMeasure(template))
          return
        }
        rows.forEach(info => result.push(this.makeMeasure(template, info)))
      })
      return result
    },
    makeMeasure(template, saved = {}) {
      const savedValues = Array.isArray(saved.values) ? saved.values : []
      return {
        template_id: template.template_id,
        values: (template.value_modules || []).map((module, moduleIndex) => {
          const current = savedValues.find(value => String(value.module_id) === String(module.module_id)) || savedValues[moduleIndex] || {}
          const units = Array.isArray(module.units) ? module.units : []
          const unit = units.find(item => String(item.unit_id) === String(current.unit_id)) || units[0] || {}
          return Object.assign({}, this.clone(module), {
            value: current.value !== undefined && current.value !== null ? current.value : '',
            unit_id: unit.unit_id || current.unit_id || '',
            unit_name: unit.unit_name || current.unit_name || ''
          })
        })
      }
    },
    addMeasure(property, templateId) {
      if (!this.canAddMeasure(property)) return
      const template = (property.measure_templates || []).find(item => String(item.template_id) === String(templateId))
      if (template) {
        const lastIndex = property.config.measure_infos.reduce((found, info, index) => {
          return String(info.template_id) === String(templateId) ? index : found
        }, -1)
        property.config.measure_infos.splice(lastIndex + 1, 0, this.makeMeasure(template))
      }
      this.enableProperty(property)
    },
    removeMeasure(property, index) {
      property.config.measure_infos.splice(index, 1)
      this.markDirty()
    },
    measureOptions(value) {
      const groups = value.values || value.value_options || value.options || []
      return Array.isArray(groups) ? groups : []
    },
    measurePrefix(value) {
      return String((value || {}).prefix || '').trim()
    },
    measureHasPrefix(measure) {
      return (measure.values || []).some(value => this.measurePrefix(value))
    },
    isStructuredProperty(property) {
      return ['measure', 'multi_value_measure', 'date_time', 'date_time_range', 'timestamp', 'timerange'].includes((property || {}).type)
    },
    isDateModule(value) {
      return String((((value || {}).validate_rule || {}).data_type) || '').toLowerCase() === 'date'
    },
    datePickerType(value) {
      return this.dateValueFormat(value).includes('HH') ? 'datetime' : 'date'
    },
    dateValueFormat(value) {
      const format = String((((value || {}).validate_rule || {}).time_format) || 'YYYY-MM-DD')
      return format.replace(/YYYY/g, 'yyyy').replace(/DD/g, 'dd')
    },
    isNumericModule(value) {
      return ['float', 'int', 'integer', 'number'].includes(
        String((((value || {}).validate_rule || {}).data_type) || '').toLowerCase()
      )
    },
    isMeasureValueRequired(value) {
      if (!Object.prototype.hasOwnProperty.call(value || {}, 'value_required')) return true
      return [true, 1, '1'].includes(value.value_required)
    },
    measureMin(value) {
      const rule = (value || {}).validate_rule || {}
      const min = Number(rule.min)
      const max = Number(rule.max)
      if (min === 0 && max === 0) return undefined
      return Number.isFinite(min) ? min : undefined
    },
    measureMax(value) {
      const rule = (value || {}).validate_rule || {}
      const min = Number(rule.min)
      const max = Number(rule.max)
      if (min === 0 && max === 0) return undefined
      return Number.isFinite(max) ? max : undefined
    },
    measureStep(value) {
      const precision = Math.max(0, Number((((value || {}).validate_rule || {}).precision) || 0))
      return precision ? Number((1 / Math.pow(10, precision)).toFixed(precision)) : 1
    },
    measureUnits(value) {
      return Array.isArray((value || {}).units) ? value.units : []
    },
    changeMeasureUnit(value, property) {
      const unit = this.measureUnits(value).find(item => String(item.unit_id) === String(value.unit_id)) || {}
      value.unit_name = unit.unit_name || ''
      this.enableProperty(property)
    },
    canAddMeasure(property) {
      return property.multi_select_max <= 0 || property.config.measure_infos.length < property.multi_select_max
    },
    isFirstMeasureForTemplate(property, index) {
      const current = property.config.measure_infos[index]
      return property.config.measure_infos.findIndex(
        info => String(info.template_id) === String(current.template_id)
      ) === index
    },
    addCustomOption(property) {
      if (
        property.type !== 'select'
        && property.multi_select_max > 0
        && property.config.value_ids.length >= property.multi_select_max
      ) {
        this.$message.warning(`${property.property_name}最多选择${property.multi_select_max}项`)
        return
      }
      this.$prompt('请输入自定义属性值', '创建属性值', {
        inputValidator: value => String(value || '').trim() ? true : '属性值不能为空'
      }).then(({ value }) => {
        const text = String(value).trim()
        if (!property.options.some(item => item.value === text)) {
          property.options.unshift({ name: text, value: text })
        }
        if (property.type === 'select') property.config.value_id = text
        else property.config.value_ids.push(text)
        this.enableProperty(property)
      }).catch(() => {})
    },
    enableProperty(property) {
      property.config.enabled = true
      this.markDirty()
    },
    showPropertyImages(property) {
      // 面料材质(785)的水洗标/吊牌图入口：可选、最多1张，配置后会应用于铺货
      const rule = property.property_pic_rule || {}
      return Boolean(rule.available || rule.required || property.config.image_urls.length)
    },
    propertyImageRequired(property) {
      // 面料材质(785)的水洗标/吊牌图不再必填，可自愿上传
      if (Number(property.property_id) === 785) return false
      return Boolean((property.property_pic_rule || {}).required)
    },
    propertyImageLimit(property) {
      // 面料材质(785)的水洗标/吊牌图最多上传1张
      if (Number(property.property_id) === 785) return 1
      const rule = property.property_pic_rule || {}
      const limit = Number(rule.max_num || rule.max_count || rule.limit_num || 0)
      return limit > 0 ? limit : 9
    },
    isUploadingImage(property) {
      return this.uploadingImageIds.some(id => String(id) === String(property.property_id))
    },
    markUploading(property) {
      const id = String(property.property_id)
      if (!this.uploadingImageIds.some(item => item === id)) this.uploadingImageIds.push(id)
    },
    clearUploading(property) {
      const id = String(property.property_id)
      this.uploadingImageIds = this.uploadingImageIds.filter(item => item !== id)
    },
    beforePropertyImageUpload(file, property) {
      if (!/^image\/(jpeg|png|webp)$/.test(String((file || {}).type || ''))) {
        this.$message.error('仅支持 JPG、PNG、WEBP 图片')
        return false
      }
      if (file.size > 10 * 1024 * 1024) {
        this.$message.error('图片大小不能超过10MB')
        return false
      }
      this.markUploading(property)
      return true
    },
    handlePropertyImageSuccess(res, file, property) {
      this.clearUploading(property)
      if (Number((res || {}).code) !== 200) {
        this.$message.error((res || {}).msg || (res || {}).message || '图片上传失败')
        return
      }
      const data = res.data || {}
      const url = data.address || data.url || ''
      if (!url) {
        this.$message.error('上传接口未返回图片地址')
        return
      }
      if (!property.config.image_urls.includes(url)) property.config.image_urls.push(url)
      this.enableProperty(property)
    },
    handlePropertyImageError(err, file, property) {
      this.clearUploading(property)
      this.$message.error((err && err.message) || '图片上传失败，请重试')
    },
    // OSS STs 直传：获取授权后直接把文件传到 OSS，不再走后端上传接口。
    // 注意：不能写成 async/返回 Promise——el-upload 会对 http-request 返回的 Promise
    // 在 settle 后再次触发 options.onSuccess/onError（以 undefined 为参数），导致误报失败。
    customUpload(options) {
      const file = options && options.file
      if (!file) {
        options.onError && options.onError(new Error('请选择图片文件'))
        return
      }
      uploadDirectOss(file, {
        purpose: 'merchant_image',
        headers: this.uploadHeaders,
        onProgress: event => options.onProgress && options.onProgress(event),
      })
        .then(data => options.onSuccess && options.onSuccess({ code: 200, data }))
        .catch(error => options.onError && options.onError(error))
    },
    removePropertyImage(property, index) {
      property.config.image_urls.splice(index, 1)
      this.markDirty()
    },
    markDirty() {
      this.dirty = true
    },
    validateProperties() {
      for (const property of this.properties) {
        if (!property.config.enabled) continue
        const config = property.config
        let hasValue = true
        if (property.type === 'select') hasValue = config.value_id !== ''
        else if (['multi_select', 'cascader_multi_select'].includes(property.type)) {
          hasValue = config.value_ids.length > 0
          if (property.multi_select_max > 0 && config.value_ids.length > property.multi_select_max) {
            return `${property.property_name}最多选择${property.multi_select_max}项`
          }
        }
        else if (property.type === 'text') hasValue = String(config.text_value).trim() !== ''
        else if (this.isStructuredProperty(property)) {
          const error = this.validateStructuredProperty(property)
          if (error) return error
          hasValue = true
        }
        if (!hasValue) return `${property.property_name}已启用，请填写属性值`
        if (this.propertyImageRequired(property) && config.image_urls.length === 0) {
          return `${property.property_name}需要上传水洗标/吊牌图`
        }
      }
      return ''
    },
    validateStructuredProperty(property) {
      const infos = property.config.measure_infos || []
      const started = infos.filter(info => info.values.some(value => String(value.value || '').trim() !== ''))
      if (!started.length) return `${property.property_name}已启用，请填写属性值`
      if (property.type !== 'multi_value_measure' && started.length > (property.measure_templates || []).length) {
        return `${property.property_name}只能填写一个值`
      }
      if (property.multi_select_max > 0 && started.length > property.multi_select_max) {
        return `${property.property_name}最多填写${property.multi_select_max}项`
      }
      for (const info of started) {
        for (const value of info.values || []) {
          const text = String(value.value === undefined || value.value === null ? '' : value.value).trim()
          if (this.isMeasureValueRequired(value) && !text) {
            return `${property.property_name}需要完整填写`
          }
          if (!text || !this.isNumericModule(value)) continue
          const number = Number(text)
          if (!Number.isFinite(number)) return `${property.property_name}需要填写有效数值`
          const min = this.measureMin(value)
          const max = this.measureMax(value)
          if (min !== undefined && number < min) return `${property.property_name}不能小于${min}`
          if (max !== undefined && number > max) return `${property.property_name}不能大于${max}`
          const precision = Math.max(0, Number(((value.validate_rule || {}).precision) || 0))
          if ((text.split('.')[1] || '').length > precision) {
            return `${property.property_name}最多保留${precision}位小数`
          }
        }
      }
      const totals = {}
      started.forEach(info => {
        ;(info.values || []).forEach(value => {
          if (value.unit_name !== '%' || String(value.value || '').trim() === '') return
          const key = `${info.template_id}_${value.module_id}`
          totals[key] = (totals[key] || 0) + Number(value.value)
        })
      })
      if (Object.values(totals).some(total => Math.abs(total - 100) > 0.001)) {
        return `${property.property_name}含量总和需等于100%`
      }
      return ''
    },
    removeExpiredOptionConfigs() {
      let removedCount = 0
      this.properties.forEach(property => {
        if (!property.config.enabled || Number(property.diy_type) === 1) return
        const validValues = new Set((property.options || []).map(option => String(option.value)))
        if (property.type === 'select') {
          const value = String(property.config.value_id || '')
          if (value !== '' && !validValues.has(value)) {
            property.config.enabled = false
            property.config.value_id = ''
            removedCount += 1
          }
          return
        }
        if (!['multi_select', 'cascader_multi_select'].includes(property.type)) return
        const values = property.config.value_ids || []
        const validSelectedValues = values.filter(value => validValues.has(String(value)))
        removedCount += values.length - validSelectedValues.length
        property.config.value_ids = validSelectedValues
        if (values.length > 0 && validSelectedValues.length === 0) {
          property.config.enabled = false
        }
      })
      return removedCount
    },
    buildAttributes() {
      const attributes = {}
      this.properties.forEach(property => {
        if (!property.config.enabled) return
        const config = {
          enabled: true,
          value_type: property.type,
          apply_mode: property.config.apply_mode,
          image_urls: property.config.image_urls.slice(0, this.propertyImageLimit(property))
        }
        if (property.type === 'select') config.value_id = property.config.value_id
        else if (['multi_select', 'cascader_multi_select'].includes(property.type)) {
          config.value_ids = property.config.value_ids.slice()
        } else if (property.type === 'text') config.text_value = property.config.text_value
        else if (this.isStructuredProperty(property)) {
          config.measure_infos = property.config.measure_infos
            .filter(info => info.values.some(value => String(value.value || '').trim() !== ''))
            .map(info => ({
              template_id: info.template_id,
              values: info.values.map(value => ({
                module_id: value.module_id,
                value: value.value,
                unit_id: value.unit_id || '',
                unit_name: value.unit_name || '',
                prefix: value.prefix || '',
                suffix: value.suffix || ''
              }))
            }))
        } else config.text_value = property.config.text_value
        attributes[String(property.property_id)] = config
      })
      return attributes
    },
    saveConfig() {
      const removedCount = this.removeExpiredOptionConfigs()
      const error = this.validateProperties()
      if (error) return this.$message.error(error)
      this.saving = true
      const action = this.globalMode ? this.saveGlobalCategory : this.saveCategory
      action({
        shopId: this.shopId,
        templateId: this.templateId,
        categoryId: this.activeCategory.category_id,
        data: { attributes: this.buildAttributes() },
        success: res => {
          this.saving = false
          if (res.code !== 200) return this.$message.error(res.msg || '保存失败')
          this.dirty = false
          this.$message.success(removedCount > 0
            ? `${res.msg || '保存成功'}，已移除 ${removedCount} 个失效属性值`
            : (res.msg || '保存成功'))
          this.activeCategory.is_configured = Object.keys(res.data || {}).length > 0
          this.loadCategories(true)
          this.$emit('saved')
        },
        fail: () => {
          this.saving = false
          this.$message.error('保存失败，请稍后重试')
        }
      })
    },
    requestClose() {
      this.handleBeforeClose(() => this.$emit('update:visible', false))
    },
    handleBeforeClose(done) {
      if (!this.dirty) {
        done()
        this.$emit('update:visible', false)
        return
      }
      this.$confirm('存在未保存的类目属性，确认关闭？', '提示', { type: 'warning' })
        .then(() => {
          this.dirty = false
          done()
          this.$emit('update:visible', false)
        })
        .catch(() => {})
    },
    clone(value) {
      return JSON.parse(JSON.stringify(value))
    }
  }
}
</script>

<style scoped>
.dialog-tip{margin:0 0 12px;color:#909399;font-size:13px;line-height:20px}.attribute-layout{display:flex;height:68vh;border:1px solid #ebeef5}.category-panel{width:34%;min-width:390px;padding:14px;border-right:1px solid #ebeef5;box-sizing:border-box}.filter-tabs{display:flex;height:44px;margin-top:4px;border-bottom:1px solid #dcdfe6}.filter-tabs button{position:relative;flex:1;border:0;background:transparent;color:#303133;font-size:14px;font-weight:600;cursor:pointer}.filter-tabs button.active{color:#409eff}.filter-tabs button.active::after{position:absolute;right:18px;bottom:-1px;left:18px;height:3px;background:#409eff;content:""}.category-list{height:calc(100% - 86px);margin:0 -14px;overflow:auto}.category-panel.global-mode .category-list{height:calc(100% - 120px)}.category-pagination{height:34px;padding-top:4px;text-align:center}.category-item{display:flex;width:100%;justify-content:space-between;gap:8px;min-height:40px;padding:9px 14px;border:0;background:transparent;box-sizing:border-box;cursor:pointer;font-size:13px;line-height:20px;text-align:left}.category-item:hover{background:#f2f4f7}.category-item.active{color:#fff;background:#409eff}.category-path{min-width:0;word-break:break-all}.configured-icon{flex:none;margin-top:3px;color:#67c23a}.category-item.active .configured-icon{color:#fff}.property-panel{flex:1;min-width:0}.property-header{display:flex;justify-content:space-between;padding:12px 18px;border-bottom:1px solid #ebeef5;font-size:13px;line-height:20px}.category-id{margin-left:10px;color:#909399}.property-list{height:calc(100% - 45px);overflow:auto}.property-section-title{padding:16px 18px 8px;color:#303133;font-size:15px;font-weight:600}.property-row{display:grid;grid-template-columns:30px minmax(105px,140px) minmax(280px,1fr) minmax(245px,280px);gap:14px;align-items:start;padding:12px 18px;border-bottom:1px solid #f0f2f5;font-size:13px}.property-enable{padding-top:8px;text-align:center}.property-name{padding-top:8px;color:#606266;text-align:right;line-height:20px}.required{margin-right:2px;color:#f56c6c}.control-full{width:100%}.apply-mode{padding-top:8px;white-space:nowrap}.apply-mode .el-radio{margin-right:22px}.measure-row{display:flex;gap:8px;align-items:flex-start;margin-bottom:8px}.measure-row:last-child{margin-bottom:0}.measure-fields{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px;flex:1;min-width:0}.measure-value{min-width:0}.measure-value:last-child:nth-child(odd){grid-column:1/-1}.measure-value-prefix{margin-bottom:4px;color:#606266;font-size:12px;line-height:18px}.measure-value-prefix.empty{visibility:hidden}.measure-unit-select{width:90px}.measure-row>.el-button{padding:8px 2px;font-size:18px}.measure-row.has-prefix>.el-button{margin-top:22px}.property-image-row{min-height:132px;padding-top:16px;padding-bottom:16px}.image-help{padding-top:6px}.image-help-button{padding:3px;border:0;background:transparent;color:#909399;font-size:14px;line-height:1;cursor:help}.image-help-button:hover,.image-help-button:focus{color:#409eff;outline:0}.property-images{display:flex;flex-wrap:wrap;gap:10px;align-items:flex-start}.property-image-item,.property-image-add{position:relative;width:96px;height:96px;border:1px solid #dcdfe6;box-sizing:border-box;background:#fff}.property-image{width:100%;height:100%}.property-image-add{display:flex;align-items:center;justify-content:center;color:#909399;font-size:30px;transition:border-color .2s,color .2s}.property-image-add:hover{border-color:#409eff;color:#409eff}.property-image-error{display:flex;align-items:center;justify-content:center;width:100%;height:100%;background:#f5f7fa;color:#c0c4cc}.property-image-remove{position:absolute;top:-7px;right:-7px;padding:2px;border-radius:50%;background:#f56c6c;color:#fff;cursor:pointer}.property-image-note{align-self:center;color:#909399;font-size:12px;line-height:20px}.property-image-add.is-uploading{border-color:#409eff;color:#409eff;cursor:wait}
@media (max-width:1600px){.category-panel{width:32%;min-width:340px}.property-row{grid-template-columns:26px 130px minmax(240px,1fr) minmax(225px,250px);gap:10px;padding-right:12px;padding-left:12px}.apply-mode .el-radio{margin-right:14px}.measure-fields{grid-template-columns:minmax(0,1fr)}.property-image-row .property-name{white-space:nowrap}}
</style>

<style>
.doudian-category-attribute-dialog{font-size:13px}.doudian-category-attribute-dialog .el-dialog__header{padding:18px 20px 12px}.doudian-category-attribute-dialog .el-dialog__title{font-size:17px;line-height:24px}.doudian-category-attribute-dialog .el-dialog__body{padding-top:10px}.doudian-category-attribute-dialog .el-input__inner{height:36px;font-size:13px;line-height:36px}.doudian-category-attribute-dialog .el-input__icon{line-height:36px}.doudian-category-attribute-dialog .el-checkbox__label,.doudian-category-attribute-dialog .el-radio__label,.doudian-category-attribute-dialog .el-button{font-size:13px}.doudian-category-attribute-dialog .el-dialog__footer{border-top:1px solid #ebeef5}.doudian-property-image-tooltip{max-width:420px;line-height:22px;white-space:normal}.doudian-property-image-tooltip .image-tooltip-title{margin-bottom:4px;font-weight:600}
.doudian-category-sync-dialog .el-dialog__title{font-size:16px}.doudian-category-sync-dialog .el-dialog__body{padding-top:12px}.doudian-category-sync-dialog .el-dialog__footer{border-top:1px solid #ebeef5}
</style>
